import { BrowseSubscriptionPlanResponse } from './pricing';

export interface PlanCardConfig {
  title: string;
  subtitle: string;
  monthlyCreditRate: number;
  yearlyCreditRate: number;
  tagline?: string;
  priceDescription: string;
  featureGroups: FeatureGroup[];
  defaultCredit: number;
  options: BrowseSubscriptionPlanResponse;
  buttonText: string;
  disabled?: boolean;
}

export interface FeatureGroup {
  title: string;
  features: FeatureItem[];
}

export interface FeatureItem {
  /** Stable identifier — catalog cell code if available, otherwise a synthetic id. */
  id: string;
  title: string;
  description?: string;
  disabled?: boolean;
  poweredBy?: string;
  comingSoon?: boolean;
}

export enum PlanActionMode {
  DOWNGRADE_FREE = 'DOWNGRADE_FREE',
  DOWNGRADE_PAID = 'DOWNGRADE_PAID',
  CANCEL_DOWNGRADE = 'CANCEL_DOWNGRADE',
  UPGRADE = 'UPGRADE',
}

interface SubscriptionDialogBaseProps {
  onConfirm: () => void;
  onCancel: () => void;
}

export interface ConfirmPlanDialogProps extends SubscriptionDialogBaseProps {}
export interface FeedbackPlanDialogProps extends SubscriptionDialogBaseProps {
  onConfirm: (comment: string) => void;
}
export interface ResultPlanDialogProps extends SubscriptionDialogBaseProps {}
